// ---- Wildlife tuning ----
// Creatures (barnyard animals + skittish wildlife) are ordinary content NPCs
// now: their bodies are `quadruped`-archetype model docs (content/models/*.json,
// built by src/model/quadruped.ts) and their behavior lives in content/npcs/
// *.json. What remains here is the one shared knob the content loader merges
// under every `flee` block (src/content/load.ts) — the central tweak surface
// for how ALL wildlife spooks; a jumpy rabbit or a bold fox overrides only
// what differs in its own JSON.

import type { FleeSpec } from "./define.ts";

/** Shared flee/scamper tuning for ALL wildlife. An NPC opts in with a `flee`
 *  block (even an empty `{}`); the loader merges these defaults under its
 *  overrides. Animals that omit it (barnyard) stay put and graze. */
export const WILDLIFE_FLEE: FleeSpec = {
  alertRadius: 9,
  runAlertMultiplier: 1.7,
  safeRadius: 16,
  fleeSpeed: 8.4,        // > player RUN_SPEED (7.6) — see config.ts
  panicMin: 1.2,
  turnRate: 6,
};
